import React from 'react';
import session from '../../../../../../services/session';
import queryString from 'query-string';
import { isClient } from '../../../../../../app/globals';
import { cloneDeep } from 'lodash';

function variantHOC(route, queryParams = {}, serverRouteParams = {}) {
  route = cloneDeep(route);

  const { Component: WrappedComponent } = route;

  return props => {
    let variant;

    variant = session.user.calculateRouteVariant({
      srcPath: route.path,
      params: isClient() ? props.match.params : queryParams,
      query: isClient() ? queryString.parse(window.location.search) : '',
      serverRouteParams,
    });
    return <WrappedComponent variant={variant} {...props} />;
  };
}

export default variantHOC;
